const remHelper = (value, baseLine = 16) => `${value / baseLine}rem`

export default remHelper
